<phx-navigation-button
  [phxLeftNavigationDisabled]="!phxCurrentPage || phxCurrentPage === 1"
  [phxRightNavigationDisabled]="!totalPages || phxCurrentPage === totalPages"
  [phxHideNavigationContent]="phxHidePagination"
  [phxLoading]="phxLoading"
  [phxSize]="phxSize"
  [phxBackground]="phxBackground"
  (phxOnLeftNavigation)="debouncedNavigateBackward()"
  (phxOnRightNavigation)="debouncedNavigateForward()"
>
  <span>{{ phxCurrentPage }}<span class="phx-pagination-slash" phxInactiveText>/</span>{{ totalPages }}</span>
</phx-navigation-button>
